import workspaceQuery from 'graphql/queries/sales/SalesOrderLineWorkspaceQuery.graphql';
import aggregateQuery from 'graphql/queries/sales/SalesOrderLineAggregateQuery.graphql';
import defaultQuery from 'graphql/queries/sales/SalesOrderLineDefault.graphql';

import { workspaceActionsForPermissions } from '../../../actions/sales/SalesOrderLineWorkspaceAction';
import { EntityType } from '../../../@types/entityTypes';

const SalesOrderLine: EntityType = {
  type: 'SalesOrderLine',
  title: 'Quote & Order Lines',
  workspace: workspaceQuery,
  workspaceUrl: '/Sales/OrderLine/Workspace',
  formTitle: 'Sales Order / Quote',
  formUrl: '/Sales/Order/Details/',
  formUrlFromFunction: (rowData) => {
    return rowData && rowData.salesOrder && rowData.salesOrder.orderType === 'QUOTE'
      ? '/Sales/Quote/Details/'
      : '/Sales/Order/Details/';
  },
  default: defaultQuery, //Used by widgets to determine fields from metaData.
  aggregate: aggregateQuery,
  screenReference: ['SALES_ORDERS', 'SALES_QUOTES'],
  actions: workspaceActionsForPermissions,
};

export default SalesOrderLine;
